import * as React from 'react'

function SvgRotateRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.965 5c.599 0 1.184.053 1.753.154l-3.037 5.252a1.5 1.5 0 002.598 1.502l3.71-6.42c.607-1.049.154-2.485-1.107-2.885A12.942 12.942 0 0014.965 2C7.802 2 2 7.816 2 14.986 2 22.155 7.802 27.97 14.965 27.97c.05 0 .1-.002.15-.007.049.005.099.008.15.008.4 0 .794-.018 1.184-.051a1.5 1.5 0 10-.258-2.99c-.303.027-.612.04-.927.04-.05 0-.1.003-.15.008a1.507 1.507 0 00-.149-.008C9.464 24.971 5 20.503 5 14.986 5 9.468 9.464 5 14.965 5zm12.455 5.463a1.5 1.5 0 10-2.841.962c.102.301.19.601.266.9a1.5 1.5 0 002.908-.735 14.916 14.916 0 00-.333-1.127zm.545 7a1.5 1.5 0 10-2.95-.546c-.113.61-.28 1.2-.496 1.766a1.5 1.5 0 102.802 1.072c.281-.736.498-1.503.644-2.292zm-3.976 7.189a1.5 1.5 0 10-2.02-2.218 9.609 9.609 0 01-1.46 1.095 1.5 1.5 0 101.566 2.56c.686-.42 1.326-.902 1.914-1.437z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgRotateRight
